/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ActionTokenStatus {
  NEW = 'NEW',
  USED = 'USED',
  EXPIRED = 'EXPIRED',
}
